import React from "react";
import { Link } from 'gatsby';
import IconArrowRight from "../../../icons/arrow-right-small-black.svg";
import LazyLoad from 'react-lazyload';


function succesStories(props) {
  const { classesForFullColumn, imageForFullColumn, imageAltForFullColumn, imageTitleForFullColumn, categoryForFullColumn, headerForFullColumn, subHeaderForFullColumn, linkForFullColumn, classesForhalfColumn1, imageForHalfColumn1, imageAltForHalfColumn1, imageTitleForHalfColumn1, categoryForHalfColumn1, headerForHalfColumn1, linkForForHalfColumn1, classesForhalfColumn2, imageForHalfColumn2, imageAltForHalfColumn2, imageTitleForHalfColumn2, categoryForHalfColumn2, headerForHalfColumn2, linkForForHalfColumn2 } = props.data;
  return (
    <div className="sucess-stories section-gap">
        <div className="container">
            <div className="section-title">
                <h2>Success Stories</h2>
                <p>Enabling businesses to thrive in the digital age.</p>
            </div>
            <div className={`services-case-study ${classesForFullColumn}`}>
                <div className="row d-flex align-v-center flex-wrap">
                    <div className="col services-case-study-image">
                        <LazyLoad>
                            <img src={ imageForFullColumn }  alt={imageAltForFullColumn} title={imageTitleForFullColumn} />
                        </LazyLoad>
                    </div>
                    <div className="col services-case-study-content">
                        <p className="small-title">{categoryForFullColumn}</p>
                        <h2 className="h3"><Link to={linkForFullColumn}>{headerForFullColumn}</Link></h2>
                        <p>{subHeaderForFullColumn}</p>
                        <Link to={linkForFullColumn} className="button right-arrow button-white-border">Read More</Link>
                    </div>
                    
                </div>
            </div>
            <div className="row two-col d-flex flex-wrap">
                <div className="col">
                    <div className={`services-case-study half-width ${classesForhalfColumn1}`}>
                        <div className="row d-flex align-v-center flex-wrap">
                            <div className="col services-case-study-image">
                            <Link to={ linkForForHalfColumn1 }><LazyLoad><img src={ imageForHalfColumn1 }  alt={ imageAltForHalfColumn1 } title={ imageTitleForHalfColumn1 } /></LazyLoad></Link>
                            </div>
                            <div className="col services-case-study-content">
                                <div>
                                <p className="small-title">{ categoryForHalfColumn1 }</p>
                                <h2 className="h3"><Link to={ linkForForHalfColumn1 }>{ headerForHalfColumn1 }<IconArrowRight /></Link></h2>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className={`services-case-study half-width ${classesForhalfColumn2}`}>
                    <div className="row d-flex align-v-center flex-wrap">
                            <div className="col services-case-study-image">
                            <Link to={ linkForForHalfColumn2 }><LazyLoad><img src={ imageForHalfColumn2 }  alt={ imageAltForHalfColumn2 } title={ imageTitleForHalfColumn2 } /></LazyLoad></Link>
                            </div>
                            <div className="col services-case-study-content">
                                <div>
                                <p className="small-title">{ categoryForHalfColumn2 }</p>
                                <h2 className="h3"><Link to={ linkForForHalfColumn2 }>{ headerForHalfColumn2 }<IconArrowRight /></Link></h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default succesStories; 